var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9999 8.9999C6.16657 8.9999 6.30824 8.94157 6.4249 8.8249C6.54157 8.70824 6.5999 8.56657 6.5999 8.3999C6.5999 8.23324 6.54157 8.09157 6.4249 7.9749C6.30824 7.85824 6.16657 7.7999 5.9999 7.7999C5.83324 7.7999 5.69157 7.85824 5.5749 7.9749C5.45824 8.09157 5.3999 8.23324 5.3999 8.3999C5.3999 8.56657 5.45824 8.70824 5.5749 8.8249C5.69157 8.94157 5.83324 8.9999 5.9999 8.9999ZM5.3999 6.7999H6.5999V2.7999H5.3999V6.7999ZM3.68324 11.5999L0.399902 8.2999V3.68324L3.68324 0.399902H8.31657L11.5999 3.68324V8.31657L8.2999 11.5999H3.68324ZM4.18324 10.3999H7.81657L10.3999 7.81657V4.18324L7.7999 1.5999H4.18324L1.5999 4.18324V7.81657L4.18324 10.3999Z",
    fill: "#445386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.cd425356fa53695871c6f3cba8ad4f8a.svg";
export { ForwardRef as ReactComponent };